import { useCallback, useEffect, useMemo, useState } from "react";
import { _get } from "../../http";
import { useParams } from "react-router";

function useVestigingRelation({ vestiging_id, history, endPoint }) {
  const [menukaartVestigingId, setMenukaartVestigingId] = useState(null);
  const [voucherVestigingId, setVoucherVestigingId] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [vestigingId, setVestigingId] = useState(vestiging_id);
  const [vestiging, setVestiging] = useState(null);
  const params = useParams();

  const extraFields = useMemo(() => {
    if (params?.id != null) {
      return {};
    } else {
      return { vestiging_id: params?.id == null ? vestiging_id : null };
    }
  }, [vestiging_id, vestigingId]);

  useEffect(() => {
    if (params?.id == null && vestiging_id) {
      _get("core/vestigingen/" + vestiging_id).then((response) => {
        setMenukaartVestigingId(
          response.data.data.menukaartVestiging > 0 ? response.data.data.menukaartVestiging : vestiging_id
        );
        setCurrency(response.data.data.valuta ?? "EUR");
        setVestiging(response.data.data);
        setVestigingId(response.data.data.id);
        setVoucherVestigingId(
          response.data.data.extra_settings.enableVoucherMasterVestiging &&
            response.data.data.extra_settings.voucherMasterVestiging_id
            ? response.data.data.extra_settings.voucherMasterVestiging_id
            : vestiging_id
        );
      });
    } else if (params?.id == null && !vestiging_id) {
      // const newUrl = endPoint.replace("core", "/manager2");
      // console.log("NOT REPLACED");
      // if (newUrl !== window.location.pathname) {
      //   console.log("REPLACED");
      //   // history.replace(newUrl);
      // }
    }
  }, [vestiging_id, params?.id]);

  const onGetModel = useCallback((model) => {
    let vestigingId = model.vestiging?.menukaartVestiging;
    if (vestigingId == null || vestigingId === 0) {
      vestigingId = model.vestiging_id;
    }
    setVestigingId(model.vestiging_id);
    setVestiging(model.vestiging);
    setMenukaartVestigingId(vestigingId);
    setCurrency(model.vestiging?.valuta ?? "EUR");
    setVoucherVestigingId(
      model.vestiging?.extra_settings?.enableVoucherMasterVestiging &&
        model.vestiging?.extra_settings?.voucherMasterVestiging_id
        ? model.vestiging?.extra_settings?.voucherMasterVestiging_id
        : model.vestiging_id
    );

    if (model.media_urls) {
      Object.keys(model.media_urls).forEach((key) => {
        if (model[key] == null) {
          model[key] = 1;
        }
      });
    }
  }, []);

  return { menukaartVestigingId, currency, vestigingId, vestiging, extraFields, onGetModel, voucherVestigingId };
}

export default useVestigingRelation;
